import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  ButtonDirective,
  DialogRef,
  MODAL_DATA,
  ModalCloseButtonDirective,
  ModalCloseTypesEnum,
  ModalComponent,
  ModalContentDirective,
  ModalTitleDirective,
  SizeScheme,
  TabComponent,
  TabsComponent
} from '@bioreferencehealth/ui-kit';
import { DownloadsModalConfig } from '../../models/downloads-modal-config';

@Component({
  templateUrl: './downloads-modal.component.html',
  styleUrls: ['./downloads-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ModalComponent,
    ModalTitleDirective,
    ModalContentDirective,
    ModalCloseButtonDirective,
    ButtonDirective,
    TabsComponent,
    TabComponent
  ]
})
export class DownloadsModalComponent {
  private readonly data = inject<DownloadsModalConfig>(MODAL_DATA);
  private readonly dialogRef = inject(DialogRef);

  public groups = this.data.groups;

  public onCloseDialog($event: ModalCloseTypesEnum): void {
    this.dialogRef.close($event);
  }

  protected readonly SizeScheme = SizeScheme;
}
